module.exports = __webpack_public_path__ + "static/Heidelbeere-ee294c31dd4dfaec55b0acef78750961.png";